<div class="btn-group" dropdown>
  <button id="report-option" type="button" dropdownToggle class="button secondary__button medium__button squre__btn"
          aria-controls="menu-dropdown">
    <em class="fa fa-ellipsis-h font-size-21"></em>
  </button>
  <div id="menu-dropdown" *dropdownMenu class="dropdown__container dropdown-menu dropdown-menu-right" role="menu"
       aria-labelledby="report-option" [ngClass]="{'inset-up': showTop}">
    <ng-container *ngIf="reportState === ReportState.CREATED && isReportDone">
      <div role="menuitem">
        <a class="dropdown-item report-option__box cursor-initial__imp">
          <img src="../../../assets/images/download-icon.svg" class="action__button__image" alt="...">
          <div>
            Download PDF
            <div class="note">
              This report <span class="color--red">has not yet been paid</span>. Please buy the report to have the
              ability to download.
            </div>
          </div>
        </a>
      </div>
      <div class="divider dropdown-divider"></div>
    </ng-container>
    <ng-container
      *ngIf="reportState !== ReportState.CREATED && isReportDone && maxStage === enumPageNumbers.CONCLUSION">
      <div role="menuitem">
        <a class="dropdown-item report-option__box" (click)="downloadReportPDF(false)">
          <img src="../../../assets/images/download-icon.svg" class="action__button__image" alt="...">
          <span>
          Download PDF
        </span>
        </a>
      </div>
      <div class="divider dropdown-divider"></div>
    </ng-container>

    <div role="menuitem">
      <a class="dropdown-item report-option__box" (click)="downloadReportPDF(true)">
        <img src="../../../assets/images/order-report-icon.svg" class="action__button__image" alt="...">

        <span>Order 3rd party report</span>
      </a>
    </div>
    <div class="divider dropdown-divider"></div>

    <ng-container *ngIf="reportState !== ReportState.CREATED && isReportDone">
      <div role="menuitem">
        <a class="dropdown-item report-option__box" (click)="openReleaseThirdPartyModal()">
          <img src="../../../assets/images/release-3rd-party-icon.svg" class="action__button__image" alt="...">
          <span>Release to 3rd Party</span>
        </a>
      </div>
      <div class="divider dropdown-divider"></div>
    </ng-container>

    <ng-container *ngIf="isReportDone && !isVersionPage">
      <div role="menuitem">
        <a class="dropdown-item report-option__box" (click)="openPreparedForModal()">
          <img src="../../../assets/images/prepared-for-icon.svg" class="action__button__image" alt="...">
          <span>Prepared For</span>
        </a>
      </div>
      <div class="divider dropdown-divider"></div>
    </ng-container>

    <ng-container *ngIf="!isVersionPage">

      <ng-container *ngIf="userService.isOrganizationUser()">
        <div role="menuitem">
          <a class="dropdown-item report-option__box" (click)="shareReportModal()">
            <img src="../../../assets/images/share-setting-icon.svg" class="action__button__image" alt="...">
            <span>Share Settings</span>
          </a>
        </div>
        <div class="divider dropdown-divider"></div>
      </ng-container>

      <ng-container *ngIf="!isShared && userService.checkAdminRole()">
        <div role="menuitem">
          <a class="dropdown-item report-option__box" (click)="transferReportModal()">
            <img src="../../../assets/images/naics-icon.svg" class="action__button__image" alt="...">
            <span>Transfer Report</span>
          </a>
        </div>
        <div class="divider dropdown-divider"></div>
      </ng-container>

      <div role="menuitem">
        <a class="dropdown-item report-option__box" (click)="gotoVersionPage()">
          <img src="../../../assets/images/main-report-icon.svg" class="action__button__image" alt="...">
          <div>
            Manage Versions
            <div class="note">
              You will be able to create copies, set active versions, delete old versions.
            </div>
          </div>
        </a>
      </div>
      <div class="divider dropdown-divider"></div>

      <div role="menuitem" *ngIf="false">
        <a class="dropdown-item report-option__box" (click)="openConnectedPopup(true)">
          <img src="../../../assets/images/integration-icon.svg" class="action__button__image" alt="...">
          <div>
            Сonnect Quickbooks
            <div class="note">
              Lorem ipsum dolor sit ametm ipsum dolor sit amet em ipsum
            </div>
          </div>
        </a>
      </div>
      <div role="menuitem" *ngIf="false">
        <a class="dropdown-item report-option__box" (click)="openConnectedPopup(false)">
          <img src="../../../assets/images/integration-icon.svg" class="action__button__image" alt="...">
          <div class="color--red">
            Disconnect Quickbooks
            <div class="note">
              Lorem ipsum dolor sit ametm ipsum dolor sit amet em ipsum
            </div>
          </div>
        </a>
      </div>
    </ng-container>

    <div role="menuitem" *ngIf="isVersionPage && !isCurrentVersion">
      <a class="dropdown-item report-option__box" (click)="setAsMain()">
        <img src="../../../assets/images/main-report-icon.svg" class="action__button__image" alt="...">
        <span>Set as Active Version</span>
      </a>
    </div>
    <div class="divider dropdown-divider"></div>

    <div role="menuitem" *ngIf="isVersionPage && isCurrentVersion">
      <a class="dropdown-item report-option__box" (click)="copyReportForVersion()">
        <img src="../../../assets/images/copy-report.svg" class="action__button__image extra__margin" alt="...">
        <span>Create Copy</span>
      </a>
    </div>
    <div role="menuitem"
         *ngIf="!isVersionPage && (userService.checkOrganizationAdmin() || createdByUserId == userService.getUserId())">
      <a class="dropdown-item report-option__box" (click)="deleteReport()">
        <img src="../../../assets/images/delete-report-icon.svg" class="action__button__image extra__margin" alt="...">
        <div class="color--red">
          Delete
          <div class="note">
            You will delete the entire report, including all versions of it.
          </div>
        </div>
      </a>
    </div>
    <div role="menuitem"
         *ngIf="isVersionPage && !isCurrentVersion && (userService.checkOrganizationAdmin() || createdByUserId == userService.getUserId())">
      <a class="dropdown-item report-option__box" (click)="deleteReportVersion()">
        <img src="../../../assets/images/delete-report-icon.svg" class="action__button__image extra__margin" alt="...">
        <span class="color--red">Delete</span>
      </a>
    </div>

  </div>
</div>
